import React from "react";
import AsideHeader from "./AsideHeader.jsx";
import { useAppContext } from "../../../Context/AppContext.jsx";
import PrincipalGroup from "./PrincipalGroup.jsx";
import UsersGroup from "./UsersGroup.jsx";
import TablesGroup from "./TablesGroup.jsx";
import HelpGroup from "./HelpGroup.jsx";
import { SlArrowLeft } from "react-icons/sl";
import { useState, useEffect, useRef } from "react";
import { PiCaretRightThin } from "react-icons/pi";

const DashboardAside = () => {
  const { clientName } = useAppContext();
  const ref = useRef(null);
  const [isOpen, setIsOpen] = useState(true);

  useEffect(() => {
    if (window.innerWidth < 700) {
      setIsOpen(false);
    }
  }, [window.innerWidth]);
  return (
    <div className="relative h-full mr-4">
      <div
        ref={ref}
        className={`${isOpen ? "animate-slide-in-left flex" : "animate-slide-in-right"} transition-all duration-500
         bg-[#FAFBFD]  h-full flex-col gap-y-10 px-2 w-[200px]`}
      >
        <AsideHeader clientName={clientName} />

        <PrincipalGroup />
        {
          ///<UsersGroup />
          ///<HelpGroup />
        }

        <TablesGroup />
      </div>
      <div className="" onClick={() => setIsOpen(!isOpen)}>
        {isOpen ? (
          <SlArrowLeft className="absolute top-[50%] -right-[20px] text-black text-[20px] hover:text-mariposa z-[100]" />
        ) : (
          <PiCaretRightThin className=" absolute top-[50%] left-[20px] text-black text-[25px] hover:text-mariposa z-[100]" />
        )}
      </div>
    </div>
  );
};

export default DashboardAside;
